import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import InscriptionComponent from "@/components/Inscription/InscriptionComponent";
import {
  TypeUser,
  UtilisateurDto,
  defaultUtilisateur,
} from "@/types/UtilisateurType";
import { authApi, fetchVilles } from "./api/authentificationApi";
import Modalgoogle from "@/components/Modals/Modalgoogle";

const InscriptionGoogle = () => {
  const navigate = useNavigate();
  const [initialValues, setInitialValues] =
    useState<UtilisateurDto>(defaultUtilisateur);
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const [villes, setVilles] = useState<string[]>([]);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);

  useEffect(() => {
    const loadVilles = async () => {
      try {
        const villes = await fetchVilles();
        setVilles(villes);
      } catch {
        setVilles([]);
      }
    };

    loadVilles();
  }, []);

  useEffect(() => {
    const utilisateurTemp = localStorage.getItem("utilisateurTemp");

    if (!utilisateurTemp) {
      navigate("/connexion");
      return;
    }

    const utilisateur = utilisateurTemp
      ? JSON.parse(utilisateurTemp) || {}
      : {};

    setInitialValues((prevValues) => ({
      ...prevValues,
      email: utilisateur.email || "",
      nom: utilisateur.nom || "",
      prenom: utilisateur.prenom || "",
      type: utilisateur.type || TypeUser.PARTICULIER,
    }));

    setIsDataLoaded(true);
  }, [navigate]);

  const handleFinaliserInscription = async (
    values: any
  ): Promise<{ success: boolean; message: string; redirectUrl?: string }> => {
    try {
      await authApi.finaliserInscriptionGoogle(values);
      localStorage.removeItem("utilisateurTemp");
      setShowSuccessPopup(true);
      return {
        success: true,
        message: "Inscription finalisée avec succès",
        redirectUrl: "/connexion",
      };
    } catch (error) {
      return {
        success: false,
        message: "Erreur lors de la finalisation de l'inscription",
      };
    }
  };

  const closePopupAndRedirect = () => {
    setShowSuccessPopup(false);
    navigate("/connexion");
  };
  const inscriptionProps = {
    typeUsers: [],
    isDisplayConditions: true,
    title: "Finalisation de l'inscription",
    description:
      "Veuillez compléter vos informations pour finaliser votre inscription.",
    advantages: [],
    images: {},
    villes,
    configFormulaire: {},
    initialValues,
    onSubmit: handleFinaliserInscription,
  };

  return (
    <div>
      <div className="text-center mt-40">
        <p className="text-lg italic text-[#000080] mt-4 mb-6">
          Vous y êtes presque ! Il ne vous reste plus qu'à compléter ces
          dernières informations pour finaliser votre inscription.
        </p>
      </div>

      {isDataLoaded ? <InscriptionComponent {...inscriptionProps} /> : null}

      <Modalgoogle isOpen={showSuccessPopup} onClose={closePopupAndRedirect}>
        <p className="text-green-600 font-semibold text-lg">
          Inscription réussie !
        </p>
        <p className="text-gray-600 mt-2">
          Un email de confirmation vous a été envoyé.
        </p>
        <button
          onClick={closePopupAndRedirect}
          className="mt-4 bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
        >
          Fermer
        </button>
      </Modalgoogle>
    </div>
  );
};

export default InscriptionGoogle;
